import React from "react";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import styles from "./dataMartModelling.module.scss";
import { DataMartWorkspace } from "../dataMartMapping/DataMartWorkspace";

const breadCrumbs = [
  { name: "Ensemble Modelling", url: "/ensembleModelling" },
  { name: "Data Vault Modelling", url: "/data-vault-modelling" },
  { name: "Data Mart Modelling", url: "/data-mart-modelling" },
  { name: "Import Data Model", url: "/importDataModel" }
];

const DataMartModelling: React.FC = () => {
  return (
    <div className={styles.page}>
      <BreadCrumbs breadCrumbsData={breadCrumbs} />
      <section style={{ marginTop: "35px" }}>
        <div className={`${styles.workspace} ${styles.workspaceFixed}`}>
          <div className={styles.workspaceFill}>
            <DataMartWorkspace />
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataMartModelling;
